import { render, staticRenderFns } from "./BotonDirecto.vue?vue&type=template&id=04440c83&scoped=true"
import script from "./BotonDirecto.vue?vue&type=script&lang=js"
export * from "./BotonDirecto.vue?vue&type=script&lang=js"
import style0 from "./BotonDirecto.vue?vue&type=style&index=0&id=04440c83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04440c83",
  null
  
)

export default component.exports